import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { ResolveEnd, Router } from '@angular/router';
import { filter, tap, switchMap } from 'rxjs/operators';
import { getActivatedComponent } from './core/helpers/route.helpers';
import { UserClaims, OktaAuthService } from '@okta/okta-angular';
import { AppInsightsService } from './core/services/app-insights.service';
import { PrintService } from './print-to-pdf/services/print.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'RentConnect';

  public routerResolveEndEvents$: Observable<any> = this.router.events.pipe(
    filter(event => event instanceof ResolveEnd),
    tap((event: ResolveEnd) => {
      this.insights.logPageView({
        name: getActivatedComponent(event.state.root).name,
        uri: event.urlAfterRedirects
      });
    })
  );

  public userContext$: Observable<UserClaims> = this.buildUserClaimsObservable();

  constructor(
    private router: Router,
    private insights: AppInsightsService,
    private okta: OktaAuthService,
    public printService: PrintService
  ) { }

  ngOnInit(): void {
    this.insights.emptyQueue();
  }

  ngOnDestroy(): void {
    this.insights.flushQueue();
  }

  private buildUserClaimsObservable(): Observable<UserClaims> {

    return from(this.okta.getUser()).pipe(
      switchMap((userClaims: UserClaims) => {
        if (userClaims === undefined || userClaims === null) {
          return this.buildUserClaimsObservable();
        }
        return of(userClaims);
      }),
      tap((userClaims: UserClaims) => {
        if (userClaims !== undefined && userClaims !== null) {

          // Set the user context to the userClaims subject.
          this.insights.setUser(userClaims.sub);
        }
      })
    );

  }

}
